import { useState } from "react";
import "./styles.css";
import BotManager from "./pages/BotManager";
import Greeting from "./pages/Greeting";
import Game from "./pages/Game";
import Victory from "./pages/Victory";

export default function App() {
  const [screen, setScreen] = useState("manager");
  const [bots, setBots] = useState([]);
  const [finalPlayers, setFinalPlayers] = useState([]);

  const handleStart = (activeBots) => {
    setBots(activeBots);
    setScreen("greeting");
  };

  const handleVictory = (players) => {
    setFinalPlayers(players);
    setScreen("victory");
  };

  if (screen === "manager") {
    return (
      <div className="App">
        <BotManager onStart={handleStart} />
      </div>
    );
  }

  if (screen === "greeting") {
    return (
      <div className="App">
        <Greeting bots={bots} onDone={() => setScreen("game")} />
      </div>
    );
  }

  if (screen === "game") {
    return (
      <div className="App">
        <Game bots={bots} onVictory={handleVictory} />
      </div>
    );
  }

  if (screen === "victory") {
    return (
      <div className="App">
        <Victory players={finalPlayers} onNewGame={() => setScreen("manager")} />
      </div>
    );
  }

  return null;
}
